<template>
  <pp-container>
    <contact-us-header
      :contact-us-text="contactUsText"
      :practice-name="practiceName"
    />
    <contact-us-form
      :practice-uuid="practiceUuid"
      :practice-name="practiceName"
    />
  </pp-container>
</template>

<script>
import ContactUsHeader from '../components/ContactUsHeader'
import ContactUsForm from '../components/ContactUsForm'
export default {
  name: 'ContactUs',
  components: {
    'contact-us-header': ContactUsHeader,
    'contact-us-form': ContactUsForm
  },
  data () {
    return {
      contactUsText: null,
      practiceName: null,
      practiceUuid: null
    }
  },
  created () {
    const params = new URLSearchParams(window.location.search)
    this.contactUsText = params.get('contactUsText') || 'Contact Us'
    this.practiceName = params.get('practiceName') || null
    this.practiceUuid = params.get('practiceUuid')
  }
}
</script>
